/**
 * Modulo do componente Boleto Deck (boletoDeck)
 */
(function(){
	angular
		.module('boletoDeckModule', []);
})();